/**
 * Platform-aware keyboard shortcut labels. Every shortcut in the app is bound
 * to `metaKey || ctrlKey`, so the hint we render must follow the OS: "⌘K" on
 * Apple devices, "Ctrl+K" everywhere else. Windows and Linux users have no ⌘
 * key and would otherwise read the hint as decoration.
 */
export function isApplePlatform(
  nav:
    | Pick<Navigator, "platform" | "userAgent">
    | undefined = typeof navigator === "undefined" ? undefined : navigator,
): boolean {
  if (!nav) return false;
  return /Mac|iPhone|iPad|iPod/i.test(nav.platform || nav.userAgent || "");
}

/** The label for the primary modifier key: "⌘" on Apple, "Ctrl" elsewhere. */
export function modifierKeyLabel(apple: boolean = isApplePlatform()): string {
  return apple ? "⌘" : "Ctrl";
}

/**
 * Formats a modifier shortcut for display: `shortcutLabel("K")` → "⌘K" on
 * Apple, "Ctrl+K" elsewhere. `key` is the printable key or symbol (e.g. "↵").
 */
export function shortcutLabel(
  key: string,
  apple: boolean = isApplePlatform(),
): string {
  return apple ? `⌘${key}` : `Ctrl+${key}`;
}
